import {
  FilterCategoryModel,
  FilterItemModel,
} from "@/models/filterItem.model";
import { KioskModel } from "@/models/kiosk.model";
import Cafe from "@/assets/cafés.svg";
import Fashion from "@/assets/fashion.svg";
import ATM from "@/assets/atm.svg";
import CustomerServiceDesk from "@/assets/info.svg";
import Desserts from "@/assets/confectionary.svg";
import Entrance from "@/assets/entrance.svg";
import FastFood from "@/assets/fast_food.svg";
import GiftCard from "@/assets/gift_cards.svg";
import HomeTech from "@/assets/home&tech.svg";
import Hypermarket from "@/assets/hypermarkets.svg";
import JewelleryWatches from "@/assets/jewellery_&_watches.svg";
import LostFound from "@/assets/box.svg";
// import LuggageBagDrop from '@/assets/luggage_bag_drop.svg';
import MallManager from "@/assets/manager.svg";
import PrayerRoomMale from "@/assets/prayer_room_female.svg";
import PrayerRoomFemale from "@/assets/prayer_room_male.svg";
import RedCrescent from "@/assets/charity.svg";
import RestroomFemale from "@/assets/female.svg";
import RestroomMale from "@/assets/men.svg";
import Taxi from "@/assets/taxi.svg";
import UberCareem from "@/assets/uber.svg";
import ValetParking from "@/assets/valet.svg";
import Wifi from "@/assets/wifi.svg";
import Share from "@/assets/coin.svg";
import Stroller from "@/assets/stroller.svg";
import Wheelchair from "@/assets/wheelchair.svg";
import BabyChangingFemale from "@/assets/changing.svg";
import BabyChangingMale from "@/assets/changing-1.svg";
import ParkingAssist from "@/assets/park_assist.svg";
import FirstAid from "@/assets/first_aid.svg";
import AccessibleParking from "@/assets/accessible-parking.svg";
import FemaleAccessibleToilet from "@/assets/accessible-toilet-F.svg";
import MaleAccessibleToilet from "@/assets/accessible-toilet-M.svg";
import FamilyParking from "@/assets/family-parking.svg";
import Hotel from "@/assets/hotel-solid.svg";
import HotelWhite from "@/assets/hotel-solid-white.svg";
import Facilities from "@/assets/facilities-ultra.svg";
import FacilitiesWhite from "@/assets/facilities-ultra-white.svg";
import { FaBagShopping, FaFaceSmile, FaUtensils } from "react-icons/fa6";
import { AmenityModel } from "proximiio-js-library/lib/models/amenity";
import Feature from "proximiio-js-library/lib/models/feature";
import Entertainment from "@/assets/entertainment.svg";
import iFly from "@/assets/ifly.svg";
import LittleExplorers from "@/assets/little-explorers.svg";
import MagicPlanet from "@/assets/magic-planet.svg";
import Snow from "@/assets/snow.svg";
import VoxCinema from "@/assets/vox-cinema.svg";

import Banks from "@/assets/project-assets/banks.svg";
import Books from "@/assets/project-assets/books.svg";
import Electronics from "@/assets/project-assets/electronics.svg";
import FashionAccessories from "@/assets/project-assets/fashions-accessoiries.svg";
import FashionLadies from "@/assets/project-assets/fashionlandies.svg";
import FashionMen from "@/assets/project-assets/fashionmen.svg";
import FashionUnisex from "@/assets/project-assets/fashionunisex.svg";
import Swimwear from "@/assets/project-assets/swimwear.svg";
import Luggage from "@/assets/project-assets/luggage.svg";
import Optics from "@/assets/project-assets/optics.svg";
import Pharmacies from "@/assets/project-assets/phamacies.svg";
import Speciality from "@/assets/project-assets/servicesandspecialitystores.svg";
import SportsWear from "@/assets/project-assets/sportswear.svg";
import Tailors from "@/assets/project-assets/tailors&textiles.svg";
import ForkKnife from "@/assets/project-assets/fork-knife.svg";
import ExpectantParking from "@/assets/project-assets/Expectant-mother-parking.svg";
import ElectricCarCharging from "@/assets/project-assets/Electric-car-charging.svg";
import DubaiMetro from "@/assets/project-assets/train-subway-tunnel-light.svg";
import Bus from "@/assets/project-assets/bus.svg";
import ParkingPay from "@/assets/project-assets/pay-station.svg";
import FoodCentral from "@/assets/project-assets/food-central.svg";
import HealthyFood from "@/assets/project-assets/healthy-food.svg";
import BabyFeeding from "@/assets/baby-feeding.svg";
import CustomerExperience from "@/assets/cx.svg";
import LuggageRoom from "@/assets/luggage-room.svg";

export const getListAsClosest = () => {
  const closestList = [];
  for (const category of filterCategories) {
    closestList.push(category.items.filter((item) => item.listAsClosest));
  }
  return closestList.flat(2);
};

export const getHiddenItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter((item) => item.hideMapIcon)) {
      list.push(item.id);
    }
  }
  return list.flat(2);
};

export const getExcludedItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter(
      (item) => item.excludeFromSearch,
    )) {
      list.push(item.id);
    }
  }
  return list.flat(2);
};

export const getHiddenUntilSelectedItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter(
      (item) => item.hideIconUntilSelected,
    )) {
      list.push(item.id);
    }
  }
  return list.flat();
};

export const filterCategories: FilterCategoryModel[] = [
  {
    title: "shop",
    id: "shop",
    color: "186,100%,42%",
    icon: FaBagShopping,
    items: [
      {
        title: "banks-financial",
        iconImage: Banks,
        id: [
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:4bb6ccdb-103b-447b-a767-1093c7465d35",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "books-stationery-toys-games-gifts",
        iconImage: Books,
        id: [
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:e6350234-3768-4498-8c66-2ee909c35f55",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "electronics-home-mobile",
        iconImage: Electronics,
        id: [
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:9af47fc2-2f17-4fe7-a205-b2132248a173",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-accessories",
        iconImage: FashionAccessories,
        id: [
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:048ac896-26d2-48de-a10b-88a1131acb61",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-child",
        iconImage: Fashion,
        id: [
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:aa433ffd-2e04-400a-8089-f95f37059b58",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-ladies",
        iconImage: FashionLadies,
        id: [
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:1ef70cce-db55-47c9-88fd-286dc3636d07",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-men",
        iconImage: FashionMen,
        id: [
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:cf253a86-69fa-4dd9-9e93-742c6678e63c",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fashion-unisex",
        iconImage: FashionUnisex,
        id: [
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:791464e5-f3eb-4e35-8b0c-0d19ccc440f9",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "household-furtniture-carpet",
        iconImage: HomeTech,
        id: [
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:309e7ec3-e079-41ad-ab38-36870a253b06",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "hypermarket",
        iconImage: Hypermarket,
        id: [
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:183212ff-ec02-4b5b-8501-4e789404b832",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "jewellery-watches",
        iconImage: JewelleryWatches,
        id: [
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:ef30ada8-0b4e-4d51-8125-b67269ba5d4d",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "lingerie-swimwear",
        iconImage: Swimwear,
        id: [
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:1cc97c59-7e15-4ea0-bb41-bcea1a5c49b9",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "luggage-leather",
        iconImage: Luggage,
        id: [
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:60936489-11bf-48f6-8c35-58c9603c789c",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "optics-sunglasses",
        iconImage: Optics,
        id: [
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:d835f400-86c3-4885-925b-8aa939a1d7b0",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "pharmacy-health-fitness-cosmetics-perfumes",
        iconImage: Pharmacies,
        id: [
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:4874a23f-a575-471f-864c-e4e77d413926",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "speciality-stores",
        iconImage: Speciality,
        id: [
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:09a7fe78-5850-4e17-93eb-6802df87557c",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "sportswear-goods",
        iconImage: SportsWear,
        id: [
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:7a597da4-5eb8-40ae-a760-569d8daa20b4",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "tailors-textiles",
        iconImage: Tailors,
        id: [
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:e84abf40-d189-4b09-b0ce-6ffc78fe6a37",
        ],
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "dine",
    id: "dine",
    color: "11,100%,61%",
    icon: FaUtensils,
    items: [
      {
        title: "cafes",
        iconImage: Cafe,
        id: [
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:8541f99c-ef87-4188-8746-5e9f66d03d43",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "chocolates-confectionery-icecream",
        iconImage: Desserts,
        id: [
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:7c34abeb-1eb0-483b-a90d-c2a57646d955",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fast-food",
        iconImage: FastFood,
        id: [
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:a8e8899c-1c4c-4686-88c8-e78c9de37112",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "restaurants",
        iconImage: ForkKnife,
        id: [
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:0c3cfe89-142d-4f62-87c0-52dedc220800",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "food-central",
        iconImage: FoodCentral,
        id: [
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:634f92b4-b5e7-49d6-bbc4-5843a4f1cf64",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "healthy-dining",
        iconImage: HealthyFood,
        id: [
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:e635703b-6be4-4e4b-9154-6c9cc7542968",
        ],
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "entertainment",
    id: "entertainment",
    color: "284,100%,38%",
    icon: FaFaceSmile,
    items: [],
  },
  {
    title: "hotels",
    id: "hotels",
    color: "208,100%,33%",
    iconImage: Hotel,
    iconImageAlt: HotelWhite,
    items: [
      {
        title: "aloft-dubai-creek",
        iconImage: Hotel,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:5e133ae6-6073-4fe4-a8e8-e2e18efc704a",
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "ibis-dubai-al-rigga",
        iconImage: Hotel,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:9329c355-893b-4bb4-a50b-37940d062cab",
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "novotel",
        iconImage: Hotel,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:d41512db-5013-45e3-b1be-8cfd8d17a1a6",
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "pullman",
        iconImage: Hotel,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:eec7067b-6a24-41b7-95e1-10f50cdbf4f5",
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "facilities",
    id: "facilities",
    color: "41,99%,61%",
    iconImage: Facilities,
    iconImageAlt: FacilitiesWhite,
    items: [
      {
        title: "female-prayer-room",
        iconImage: PrayerRoomFemale,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:c88e2a23-5edb-4d1b-b45d-1ebd0cd3d92c",
        type: "list",
      },
      {
        title: "male-prayer-room",
        iconImage: PrayerRoomMale,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:159c9276-29cc-4efe-a15d-53feeffcd151",
        type: "list",
      },
      {
        title: "female-toilet",
        iconImage: RestroomFemale,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:12018956-2a1c-4d1a-b613-c6ae2990584f",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
      },
      {
        title: "male-toilet",
        iconImage: RestroomMale,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:6ee38849-8a40-47ee-9c25-0add73b8c442",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
      },
      {
        title: "atm",
        iconImage: ATM,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:2a9a5e4d-5548-4a4b-9a4b-2f9edb3784bd",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
      },
      {
        title: "customer-service-desk",
        iconImage: CustomerServiceDesk,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:7c56444a-adfb-4f70-97b3-21f558be4851",
        type: "closest",
        hideIconUntilSelected: true,
      },
      {
        title: "baby-care-room",
        iconImage: BabyFeeding,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:33bb7a9e-39e7-471c-a4ef-3b907c944ec1",
        type: "closest",
        hideIconUntilSelected: true,
      },
      {
        title: "baby-changing-room-female",
        iconImage: BabyChangingFemale,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:12018956-2a1c-4d1a-b613-c6ae2990584f",
        type: "closest",
        excludeFromSearch: true,
      },
      {
        title: "baby-changing-room-male",
        iconImage: BabyChangingMale,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:6ee38849-8a40-47ee-9c25-0add73b8c442",
        type: "closest",
        excludeFromSearch: true,
      },
      {
        title: "female-accessible-toilet",
        iconImage: FemaleAccessibleToilet,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:12018956-2a1c-4d1a-b613-c6ae2990584f",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
      },
      {
        title: "male-accessible-toilet",
        iconImage: MaleAccessibleToilet,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:6ee38849-8a40-47ee-9c25-0add73b8c442",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
      },
      {
        title: "dubai-metro",
        iconImage: DubaiMetro,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:79bb82c2-a595-4783-9b82-4ea51d0cc024",
        type: "list",
      },
      {
        title: "taxi-pickup",
        iconImage: Taxi,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:4b70cc85-301d-4b00-8b09-637c63564ab6",
        type: "list",
        hideIconUntilSelected: true,
      },
      {
        title: "uber-careem",
        iconImage: UberCareem,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:2b1e5481-68f1-4af2-bbf2-b6baa237e8bb",
        type: "list",
        hideIconUntilSelected: true,
      },
      {
        title: "bus-stop",
        iconImage: Bus,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:f3716563-6da9-428a-846a-b126ae4a0433",
        type: "list",
      },
      {
        title: "entrance",
        iconImage: Entrance,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:c818c6e5-8c72-42c8-a914-d7a02a509984",
        type: "list",
        hideIconUntilSelected: true,
      },
      {
        title: "luggage-room",
        iconImage: LuggageRoom,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:17f44c3e-729b-49b7-8f87-67c8186acd1f",
        type: "list",
        hideIconUntilSelected: true,
      },
      {
        title: "valet-parking",
        iconImage: ValetParking,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:d1dfc9d9-3e72-437b-ba0d-32386fc3bbed",
        type: "list",
        excludeFromSearch: true,
      },
      /*{
        title: "share-vip-parking",
        iconImage: VipParking,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:6a2c50f4-e5ec-4e16-bf67-19ccc6a70667",
        type: "list",
        excludeFromSearch: true,
      },*/
      {
        title: "pod-parking",
        iconImage: AccessibleParking,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:7bc9bf1b-ddea-44bc-9b8d-145eef8cdc6d",
        type: "list",
        excludeFromSearch: true,
      },
      {
        title: "family-parking",
        iconImage: FamilyParking,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:6e0b9338-1341-4d6c-83c6-873844ad79ce",
        type: "list",
        excludeFromSearch: true,
      },
      {
        title: "expectant-mother-parking",
        iconImage: ExpectantParking,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:a3dbee06-ddc1-4323-86fd-515fb2ad3347",
        type: "list",
        excludeFromSearch: true,
      },
      {
        title: "electric-car-charging",
        iconImage: ElectricCarCharging,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:3c0df7ac-5a8a-47d0-b016-fa40d8abe6d3",
        type: "list",
        excludeFromSearch: true,
      },
      {
        title: "parking-pay-station",
        iconImage: ParkingPay,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:9fae9063-45f6-4a8f-ae63-da8ea282a30b",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
      },
      {
        title: "find-my-car-kiosk",
        iconImage: ParkingAssist,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:cd9ce017-d71c-466c-9cd4-d13b656bb2c8",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
      },
      {
        title: "charity",
        iconImage: RedCrescent,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:1a687aec-aa47-4aa2-b232-28faed8f5f07",
        type: "list",
        hideIconUntilSelected: true,
      },
      {
        title: "lost-found",
        iconImage: LostFound,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:cd5b7786-9464-460b-a3f8-3397e5021047",
        type: "closest",
        hideMapIcon: true,
      },
      {
        title: "first-aid-room",
        iconImage: FirstAid,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:5d498451-3be6-4829-8038-41526582198a",
        type: "closest",
        hideIconUntilSelected: true,
      },
      {
        title: "wheelchairs",
        iconImage: Wheelchair,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:0bf74c0d-bbdd-48db-9396-a3290dd55c50",
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
      },
      {
        title: "baby-strollers",
        iconImage: Stroller,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:a99b3a9f-d3cc-41d9-badf-0b00155fc585",
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
      },
      {
        title: "gift-card",
        iconImage: GiftCard,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:7c56444a-adfb-4f70-97b3-21f558be4851",
        type: "closest",
        hideIconUntilSelected: true,
      },
      {
        title: "mall-management-office",
        iconImage: MallManager,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:d6849e3c-bedb-42e6-9b23-151be0d9d3c1",
        type: "closest",
        hideIconUntilSelected: true,
      },
      {
        title: "cx-hub",
        iconImage: CustomerExperience,
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:778649e0-d976-45ee-8f2e-b116cc023bfd",
        type: "list",
        hideIconUntilSelected: true,
      },
      {
        title: "parking-bays",
        id: [
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:08f91455-db9b-4e73-b0bd-4052280f7b7f",
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:ae576015-46c9-40bd-90ba-9c8c9e545e69",
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:e9283c05-f2e2-4353-8710-bbb29662a463",
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:35cd70c0-1b97-449a-8f0f-71956971e4e7",
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:2a050c87-f50f-4605-a1d0-93ecf638226d",
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:2c79ebaf-66fb-42be-8b5e-b38f7901aa03",
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:5dba9400-faec-45dd-8092-321f3ccf5729",
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:edce6f45-a0a7-4729-8b46-93eb41fffd7a",
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:467eb908-c636-4ce1-a5a1-040d5359bf79",
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:d9f7df41-a3f0-4c32-951a-5de644cdc2e6",
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:fa6a2efd-5b53-4e8e-bdcb-3347d7277b8d",
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:335eebc8-550c-48b5-95a7-aafdd93160d6",
        ],
        type: "list",
        listed: false,
        hideIconUntilSelected: true,
        excludeFromSearch: true,
      },
      {
        title: "vacant",
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:519446f9-49f2-4d1b-b03b-12c8c3e6aec0",
        type: "list",
        listed: false,
        hideMapIcon: true,
        excludeFromSearch: true,
      },
      {
        title: "others",
        id: [
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:2958fa04-1bed-491e-a37d-ce4a46cf2ce5",
        ],
        type: "list",
        listed: false,
        hideMapIcon: true,
        excludeFromSearch: true,
      },
      {
        title: "notlistedbuttobehide",
        id: [
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:37285631-bae4-4ef1-b911-0eef6ca46e86",
          "e147dd9f-6ffb-4e2f-9958-01d729f655dc:4bb8d803-4cb1-4707-b5cf-7badbcc3481b",
        ],
        type: "list",
        listed: false,
      },
      {
        title: "parking",
        id: "e147dd9f-6ffb-4e2f-9958-01d729f655dc:1fd23193-a399-442c-886d-14a999b402c3",
        type: "list",
        listed: false,
        hideIconUntilSelected: true,
        excludeFromSearch: true,
      },
      {
        title: "wifi",
        iconImage: Wifi,
        type: "info",
        listed: false,
        content: {
          en: `
						<h3 class="text-xl font-bold my-4">#Free_ Mall_WiFi</h3>
						<p class="font-bold mb-4">We Understand that staying connected is important in today’s world. That’s why we’re excited to offer #Free_ Mall_WiFi to all our shoppers.</p>
						<ul class="mb-4">
							<li>1. Please choose #Free_Mall_WiFi from the list of Wi-Fi networks.</li>
							<li>2. Your device should automatically be taken to our login page.</li>
							<li>3. Enter your details and follow the instructions to gain high-speed internet service.</li>
						</ul>
					`,
          ar: `
						<h3 class="text-xl font-bold my-4">#Free_ Mall_WiFi</h3>
						<p class="font-bold mb-4">نحن نتفهم أن البقاء على اتصال أمر مهم في عالم اليوم.لهذا السبب نحن متحمسون لتقديم خدمة فري وايفاي لجميع المتسوقين لدينا</p>
						<ul>
							<li>من قائمة الشبكات #Free_Mall_WiFi الرجاء اختيار</li>
							<li>يجب أن يتم نقل جهازك تلقائيا إلى صفحة تسجيل الدخول الخاصة بنا</li>
							<li>أدخل بياناتك واتبع التعليمات للحصول على خدمة إنترنت عالي السرعة</li>
						</ul>
					`,
        },
      },
      {
        title: "share",
        iconImage: Share,
        type: "info",
        listed: false,
        content: {
          en: `
						<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary mt-4 block text-lg font-semibold">Join SHARE</a>
						<h3 class="text-2xl font-bold mb-6">Get More At City Centre Mirdif</h3>
						<p class="mb-6">As a member of the SHARE rewards programme, you get cash back in points at all stores and restaurants in City Centre Mirdif and beyond. Join the SHARE programme now – it’s free and will only take you a few minutes.</p>
						<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary text-lg font-semibold">Join SHARE Rewards</a>
					`,
          ar: `
					<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary mt-4 block text-lg font-semibold">سجلوا في تطبيق شير</a>
					<h3 class="text-2xl font-bold mb-6">احصلوا على المزيد في سيتي سنتر مردف</h3>
					<p class="mb-6">تخولكم عضويتكم في برنامج المكافآت شير استرداد بعض النقود في صورة نقاط لدى جميع المتاجر والمطاعم في سيتي سنتر مردف وأماكن أخرى خارج المول. انضموا إلى برنامج المكافآت شير الآن - فهو مجاني ولا يلزم لانضمامكم إليه سوى دقائق معدودة.</p>
					<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary text-lg font-semibold">سجلوا في تطبيق شير</a>
					`,
        },
      },
    ],
  },
];

filterCategories.push({
  title: "hidden",
  id: "hidden",
  listed: false,
  items: [
    {
      title: "hidden",
      id: getHiddenUntilSelectedItems() as string[],
      type: "list",
      listed: false,
    },
  ],
});

export const kiosks: KioskModel[] = [];

export const excludedAmenities: string[] = getExcludedItems() as string[];

// Function to build additional filters based on amenities and features
export const buildAdditionalFilters = ({
  amenities,
  features,
  language,
}: {
  amenities: AmenityModel[] | null;
  features: Feature[] | null;
  language: string;
}): FilterItemModel[] | void => {
  // Early exit if amenities or features are missing
  if (!amenities) {
    console.error("amenities is null");
    return;
  }

  if (!features) {
    console.error("features is null");
    return;
  }

  // Define amenity titles and their mapping to ids/features
  const amenityMapping: {
    [key: string]: {
      amenity?: AmenityModel;
      features: Feature[];
      icon: string;
    };
  } = {
    "Snow/Ski": { amenity: undefined, features: [], icon: Snow },
    "Vox Cinema": { amenity: undefined, features: [], icon: VoxCinema },
    "Magic Planet": { amenity: undefined, features: [], icon: MagicPlanet },
    iFLY: { amenity: undefined, features: [], icon: iFly },
    "Little Explorers": {
      amenity: undefined,
      features: [],
      icon: LittleExplorers,
    },
    Entertainment: { amenity: undefined, features: [], icon: Entertainment },
  };

  // Map amenities to their respective amenity titles
  for (const amenity of amenities) {
    if (amenityMapping[amenity.title]) {
      amenityMapping[amenity.title].amenity = amenity;
    }
  }

  // Map features to their respective amenities
  for (const feature of features) {
    for (const key in amenityMapping) {
      const { amenity } = amenityMapping[key];
      if (feature.properties?.amenity === amenity?.id) {
        amenityMapping[key].features.push(feature);
      }
    }
  }

  // Utility function to retrieve a translated title
  const getTranslatedTitle = (feature: Feature): string => {
    const { title_i18n, title } = feature.properties || {};
    return title_i18n?.[language] || title_i18n?.en || title;
  };

  const items: FilterItemModel[] = [];

  // Create filter items for each amenity based on available features
  for (const key in amenityMapping) {
    const { amenity, features, icon } = amenityMapping[key];

    if (amenity && features.length > 0) {
      let itemTitle: string | undefined;

      // If there is only one feature, use the feature title
      if (features.length === 1) {
        itemTitle = getTranslatedTitle(features[0]);
      }

      // Set up the item object for the filter list
      const baseItem: FilterItemModel = {
        title: key.toLowerCase().replace(/\s/g, "-"), // Convert title to kebab-case
        translatedTitle: itemTitle,
        iconImage: icon,
        id: [amenity.id],
        hideMapIcon: true,
        type: "list",
      };

      // Push items to the list based on the type (list or single)
      if (key === "Entertainment") {
        // For "Entertainment", push individual features
        features.forEach((feature) => {
          items.push({
            ...baseItem,
            type: "single",
            title: getTranslatedTitle(feature)
              .toLowerCase()
              .replace(/\s/g, "-"), // Convert title to kebab-case
            translatedTitle: getTranslatedTitle(feature),
            featureId: feature.id,
          });
        });
      } else {
        // For other amenities, push as a list
        items.push(baseItem);
      }
    }
  }

  const entertainmentIndex = filterCategories.findIndex(
    (category) => category.id === "entertainment",
  );
  filterCategories[entertainmentIndex].items = items;
};
